@if (
  (isSuperAdminRoute$ | async) === false &&
  (isAutomationsRoute$ | async) === false &&
  (trialDetails$ | async); as trialDetails
  ) {
  @if (trialDetails?.onTrial) {
    <glxy-alert
      type="info"
      [borderRadius]="false"
      [showAction]="true"
      [actionTitle]="'TRIAL_BANNER.ACTION_BUTTON' | translate"
      (actionClick)="openSalesVideo()"
      >
      <strong>{{ trialDetails.tierName | translate }}{{ 'TRIAL_BANNER.PLAN' | translate }}</strong>
      @if ({ remainingDays: remainingDays$ | async }; as data) {
        @if (data.remainingDays === 0) {
          <span class="days-remaining">
            {{ 'TRIAL_BANNER.ENDS_TODAY' | translate }}
          </span>
        }
        @if (data.remainingDays > 0) {
          <span>
            {{ 'TRIAL_BANNER.DESCRIPTION' | translate: { date: trialDetails.endDate | glxyDate: dateFormat.longDate } }}
          </span>
          <span class="days-remaining" [ngPlural]="data.remainingDays">
            <ng-template ngPluralCase="=1">
              {{ 'TRIAL_BANNER.DAY_REMAINING' | translate }}
            </ng-template>
            <ng-template ngPluralCase="other">
              {{ 'TRIAL_BANNER.DAYS_REMAINING' | translate: { days: data.remainingDays } }}
            </ng-template>
          </span>
        }
      }
      <span class="learn-more" (click)="learnMore()">
        {{ 'TRIAL_BANNER.LEARN_MORE' | translate }}
      </span>
    </glxy-alert>
  }
}
